<table>
    <thead>
        <tr>
            <th>
                Field
            </th>
            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>
    </thead>

    <tbody>
        <tr>
            <td>
                Include Resources (formerly cloud apps)
                <mat-icon matTooltip="Resources that the policy applies to, including apps, internet resources, actions, or authentication context">info</mat-icon>
            </td>

            <td>
                <mat-label *ngFor="let item of policy?.conditions?.applications?.includeApplications">
                    {{item}}
                </mat-label>
            </td>

            <td>
                <mat-radio-group [disabled]="readOnly" [(ngModel)]="includeApplicationRadioGroup" (change)="toggleIncludeApplications()">
                    <div class="mb-3">
                        <mat-radio-button value="All">All resources (formerly 'All cloud apps') </mat-radio-button>
                    </div>

                    <div class="mb-3">
                        <mat-radio-button value="None">None</mat-radio-button>
                    </div>
                </mat-radio-group>
            </td>

            <td>
                <sway-baseline-status  *ngIf="policy?.id" [hasError]="errorsString?.includes('includeApplications')
                        || (!policy?.conditions?.applications?.includeApplications && (includeApplicationsController.value > 0))

                        ">
                </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>

            </td>
        </tr>
    </tbody>
</table>
